<script>
import resources from './resources'

export default {
  name: 'professional-addresses-index',
  mixins: [resources]
}
</script>

<template lang="pug">
page(title="Endereços dos Estabelecimentos", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        .nav-tabs-wrapper
          ul.nav.nav-tabs.nav-340
            li.active
              a Listagem
            li
              router-link(:to="{ name: 'professional.company.addresses.create'}")
                a(href='#') Cadastro
        .col-xs-12.white-bg.wrapper(v-if="loading")
          .row.border-bottom-light
            spinner(:show="true")
        .col-xs-12.white-bg.wrapper(v-if="!loading")
          .row.border-bottom-light
            .col-sm-offset-9.col-sm-3
              form.col-sm-12
                .form-group.busca(style='margin-top:30px;')
                  .row
                    .col-xs-9
                      input#buscar.form-control(v-model="search.name_and_street", type='text', placeholder='Buscar Endereços')
                    .col-xs-3
                      button.search(@click.prevent="doLoadAll()")
                        span.icon 
            card-add(label='Novo<br>Endereço', route='professional.company.addresses.create', icon='')

            .list-item.white-bg.list-item(v-for="address in addresses")
              .row.border-bottom
                h4.col-xs-8(v-tooltip="address.name") {{ address.name_small }}
                .col-xs-4
                  .exclude-list(@click.prevent="doDelete(address)")
                    span.icon 
                  router-link(:to="{name: 'professional.company.addresses.edit', params: {id: address.id}}")
                    a(href='#')
                      .edit-list
                        span.icon 
              .list-info
                strong Consultório Médico
                br
                |                 {{ address.label }}
                br
                |                 {{ address.label2 }}
          .pagination
            pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/professional/company/addresses/index/index.vue